import { EImportSectionsTarget } from '@constants';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { ImportActivityDrawer } from './ImportActivityDrawer';
import { OnImportActivitiesOptions } from './types';
import { useImportActivityDrawer } from './useImportActivityDrawer';

import { Icon } from '@/components/Icon';
import { useMutateSection, useProfile } from '@/store';

type ImportActivityProps = {
  courseId: string;
  sectionId: string;
  target: EImportSectionsTarget;
  fetchOnlyParentsCourses?: boolean;
};

export const ImportActivity: React.FC<ImportActivityProps> = ({
  courseId,
  sectionId,
  target,
  fetchOnlyParentsCourses
}) => {
  const { t } = useTranslation('ManagerBaseContentDetailTranslations');
  const { openDrawer } = useImportActivityDrawer();
  const { importActivities, isImportingActivities } = useMutateSection();
  const {
    roleCheck: { isManager }
  } = useProfile();

  if (!isManager) return null;

  const handleImportActivities = ({
    activities,
    isSyncedToParent,
    onSuccess
  }: OnImportActivitiesOptions) => {
    importActivities(
      {
        courseId,
        sectionId,
        activityIds: activities.map(activity => activity._id),
        isSyncedToParent
      },
      { onSuccess }
    );
  };

  return (
    <>
      <Button
        size="middle"
        type="default"
        onClick={() => openDrawer(handleImportActivities, sectionId)}
        icon={<Icon i="ImportExport" />}>
        {t('IMPORT_ACTIVITY')}
      </Button>
      <ImportActivityDrawer
        target={target}
        sectionId={sectionId}
        fetchOnlyParentsCourses={fetchOnlyParentsCourses}
        isImporting={isImportingActivities}
      />
    </>
  );
};
